<template>
	<div>
		<iframe src="static/map.html" frameborder="0" style="width:100%;height:400px;"></iframe>
	</div>
</template>
 
<script>
export default {
	data(){
		return{}
	},
}
</script>
 
